import { AssistChip, Stack, Text } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IApiUserBadge } from '~/lib/api/modules/UserBadges';
import { Color } from '~/components/atoms/Color';
import { Table } from '~/components/molecules/Table';
import { getFormattedIapProductPrice } from '~/components/organisms/fields/IapProductSelector/getFormattedIapProductPrice';
import { iapProducts } from '~/components/organisms/fields/IapProductSelector/IapProductsData';
import { UserBadgeListItemMenu } from './UserBadgeListItemMenu';

export type IUserBadgeListItemProps = {
  userBadge: IApiUserBadge;
};

export const UserBadgeListItem: React.FC<IUserBadgeListItemProps> = (props) => {
  const { userBadge } = props;
  const { t } = useTranslation();

  const productId = userBadge.storeProductId;
  const iapProduct = productId
    ? iapProducts.find(({ _id }) => _id === productId)
    : undefined;

  return (
    <Table.Row>
      <Stack
        as={Table.BodyAction}
        horizontal
        gap={3}
        href={`/apps/${userBadge.appId}/badges/${userBadge._id}`}
      >
        <Color hex={userBadge.color} />
        <Stack gap={1}>
          {userBadge.name ? (
            <Text variant="title" size="sm" truncate>
              {userBadge.name}
            </Text>
          ) : null}
          {userBadge.description ? (
            <Text variant="body" size="sm" dimmed truncateLines={2}>
              {userBadge.description}
            </Text>
          ) : null}
        </Stack>
      </Stack>

      <Stack as={Table.Body} horizontal gap={2}>
        {iapProduct ? (
          <AssistChip
            label={getFormattedIapProductPrice(iapProduct.customerPrice)}
          />
        ) : null}
      </Stack>

      <Stack as={Table.Body} horizontal gap={2}>
        {userBadge.isDefault ? (
          <AssistChip label={t('UserBadgeListItem.default')} />
        ) : null}
      </Stack>

      <Stack as={Table.Body} horizontal justify="end">
        <UserBadgeListItemMenu userBadge={userBadge} />
      </Stack>
    </Table.Row>
  );
};
